import { h } from 'preact';
import styles from './ProductCardSkeleton.module.scss';
export function ProductCardSkeleton({ layout = 'grid', showPromotion = false }) {
    const containerClass = layout === 'grid' ? styles.skeletonCard : styles.skeletonCardList;
    return (h("div", { class: containerClass },
        h("div", { class: styles.skeletonImage },
            h("div", { class: styles.skeletonShimmer })),
        h("div", { class: styles.skeletonInfo },
            h("div", { class: styles.skeletonBrandAndRating },
                h("div", { class: styles.skeletonBrand }),
                h("div", { class: styles.skeletonRating })),
            h("div", { class: styles.skeletonTitle }),
            h("div", { class: styles.skeletonPrice }),
            h("div", { class: styles.skeletonColorSwatches },
                h("div", { class: styles.skeletonColorSwatch }),
                h("div", { class: styles.skeletonColorSwatch }),
                h("div", { class: styles.skeletonColorSwatch })),
            h("div", { class: styles.skeletonAvailability }),
            showPromotion && h("div", { class: styles.skeletonPromotion }))));
}
